<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zI6QdA/tc-custom/9780830866991.jpg?1696025000918" alt="This image is the cover for the book A Week in the Life of Corinth, A Week in the Life Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Week in the Life of Corinth, A Week in the Life Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Ben Witherington III attempts to reenchant our reading of Paul in this creative reconstruction of ancient Corinth. Following a fictitious Corinthian man named Nicanor through an eventful week of business dealings and conflict, you will encounter life at various levels of Roman society--eventually meeting Paul himself and gaining entrance into the Christian community there. The result is an unforgettable introduction to life in a major center of the New Testament world. Numerous full-page text boxes expand on a variety of aspects of life and culture as we encounter them in the narrative.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ben Witherington III
      </h2>
      
      <p class="authorDescription body article"><p>Ben Witherington III (PhD, University of Durham) is Jean R. Amos Professor of New Testament for Doctoral Studies at Asbury Theological Seminary. A prominent evangelical scholar, he is also on the doctoral faculty at St. Andrews University in Scotland. Witherington has written over forty books, including<em>The Jesus Quest</em> and <em>The Paul Quest,</em> both of which were selected as top biblical studies works by <em>Christianity Today.</em> His other works include <em>The Indelible Image</em>, <em>Women and the Genesis of Christianity</em>, <em>The Gospel Code</em>, <em>A Week in the Life of Corinth</em> and commentaries on the entire New Testament. He also writes for many church and scholarly publications and is a frequent contributor to <em>Patheos</em> and <em>Beliefnet</em>. Witherington is an elected member of the prestigious Studiorum Novi Testamenti Societas, a society dedicated to New Testament studies. He is a John Wesley Fellow for Life, a research fellow at Cambridge University and a member of numerous professional organizations, including the Society of Biblical Literature, Society for the Study of the New Testament and the Institute for Biblical Research. He previously taught at institutions like Ashland Theological Seminary, Vanderbilt University, Duke Divinity School and Gordon-Conwell Theological Seminary. An ordained pastor in the United Methodist Church and a popular lecturer, Witherington has presented seminars for churches, colleges and biblical meetings around the world. He has led numerous study tours through the lands of the Bible and is known for bringing the text to life through incisive historical and cultural analysis. Along with many interviews on radio and television networks across the country, Witherington has been seen in programs such as<em>60 Minutes</em>, <em>20/20</em>, <em>Dateline</em> and the Peter Jennings ABC special <em>Jesus and Paul—The Word and the Witness</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5574ed4e